import api from './api';

export interface HelpTopic {
  id: number;
  title: string;
  has_form: boolean;
  form_fields: Array<{
    name: string;
    label: string;
    type: string;
  }> | null;
  children: HelpTopic[] | null;
}

export interface UploadFileResponse {
  success: boolean;
  file_id: number;
  url: string;
  width?: number;
  height?: number;
}

export interface CreateTicketRequest {
  body: string;
  help_topic_id: number;
  actor_type: number;
  form_data?: Record<string, string>;
  attachments?: number[];
}

export interface CreateTicketResponse {
  success: boolean;
  message: string;
  data?: any;
}

export interface GetHelpTopicsResponse {
  success: boolean;
  topics: HelpTopic[];
  actor_type: number;
}

export interface OrderItem {
  id: number;
  title: string;
  quantity: number;
  price: number;
  product: {
    id: number;
    name: string;
    photos: Array<{
      id: number;
      resized: {
        sm: string;
      };
    }>;
  };
}

export interface OrderParcel {
  id: number;
  vendor: {
    id: number;
    title: string;
    logo?: {
      resized: {
        sm: string;
      };
    } | null;
  };
  items: OrderItem[];
}

export interface CustomerOrder {
  id: number;
  created_at: string;
  paid_at: string;
  parcels: OrderParcel[];
}

export interface GetCustomerOrdersResponse {
  data: CustomerOrder[];
  next_cursor?: string;
  previous_cursor?: string;
}

export const supportService = {
  /**
   * Upload a file for use in support ticket
   */
  async uploadFile(file: File): Promise<UploadFileResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await api.post<UploadFileResponse>(
      '/api/support/upload-file',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return data;
  },

  /**
   * Create a support ticket
   */
  async createTicket(request: CreateTicketRequest): Promise<CreateTicketResponse> {
    const { data } = await api.post<CreateTicketResponse>(
      '/api/support/create-ticket',
      request
    );

    return data;
  },

  /**
   * Get help topics based on actor type
   */
  async getHelpTopics(parentId: number): Promise<GetHelpTopicsResponse> {
    const { data } = await api.get<GetHelpTopicsResponse>(
      '/api/support/help-topics',
      {
        params: { parent_id: parentId },
      }
    );

    return data;
  },

  /**
   * Get customer orders for order selection
   */
  async getCustomerOrders(perPage: number = 10, cursor?: string): Promise<GetCustomerOrdersResponse> {
    const { data } = await api.get<GetCustomerOrdersResponse>(
      '/api/support/customer-orders',
      {
        params: { per_page: perPage, ...(cursor && { cursor }) },
      }
    );

    return data;
  },
};

